// extracted by mini-css-extract-plugin
export default {"container":"courseAboutInfo_container__sVTPS","title":"courseAboutInfo_title__No9EU","content":"courseAboutInfo_content__M+U0p"};